import axios from "axios";
import React, { useState } from "react";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { useAuthContext } from "../../../hooks/useAuthContext";

export default function DeleteProfilePictuteModal({
  id,
  cancelModal,
  fetchData,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [complete, setCompelte] = useState(false);
  const { user } = useAuthContext();

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const deleteResponse = await axios.delete(
        `${ApiConnectionString}/api/ClubProfileImage/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (deleteResponse.status === 200) {
        setCompelte(true);
      }
    } catch (error) {
      console.error("Error deleting profile image:", error);
      // Handle the error as needed, e.g., show a message to the user
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  } else {
    if (complete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Image deleted</p>
            </div>
            <p>The image was deleted successfully.</p>

            <div className="send-modal-footer">
              <button
                className="pointer cancelButton fw-bold mx-2 px-3"
                onClick={() => {
                  fetchData();
                  cancelModal();
                }}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Delete Profile Image</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>

            <p>Are you sure you want to delete the profile image?</p>

            <div className="send-modal-footer">
              <button className="delete-button mx-3" onClick={handleDelete}>
                Confirm
              </button>
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
